import { stringToSlug } from '../../plugins/utils'
import localforage from 'localforage'
import { app } from '../../config'

const localstorage = localforage

localstorage.config({
  driver: localforage.LOCALSTORAGE, // Force WebSQL; same as using setDriver()
  name: stringToSlug(app.name)
})

export default localstorage
